'use client';

import { usePathname } from 'next/navigation';
import { defaultLocale, type Locale } from '@/i18n/config';
import { splitLocale } from '@/i18n/routing';

/**
 * The current locale, for Client Components.
 *
 * Read from the URL rather than passed down through a provider: the pathname
 * *is* the locale here, `usePathname` is already subscribed to it, and there is
 * no window in which a context value and the visible route disagree — which
 * matters during a language switch, when the whole point is to know the exact
 * moment the new locale has landed.
 *
 * `next/root-params` is the equivalent on the server, and cannot be used here.
 */
export function useLocale(): Locale {
  return splitLocale(usePathname()).locale ?? defaultLocale;
}
